var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircleOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.96 9.26a.9.9 0 011.28 1.28l-4.6 4.6a.9.9 0 01-1.28 0l-2.6-2.6a.9.9 0 011.28-1.28L11 13.23l3.96-3.97z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.1a9.9 9.9 0 110 19.8 9.9 9.9 0 010-19.8zm0 1.8a8.1 8.1 0 100 16.2 8.1 8.1 0 000-16.2z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE0Ljk2IDkuMjZhLjkuOSAwIDAgMSAxLjI4IDEuMjhsLTQuNiA0LjZhLjkuOSAwIDAgMS0xLjI4IDBsLTIuNi0yLjZhLjkuOSAwIDAgMSAxLjI4LTEuMjhMMTEgMTMuMjNsMy45Ni0zLjk3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyLjFhOS45IDkuOSAwIDEgMSAwIDE5LjggOS45IDkuOSAwIDAgMSAwLTE5LjhabTAgMS44YTguMSA4LjEgMCAxIDAgMCAxNi4yIDguMSA4LjEgMCAwIDAgMC0xNi4yWiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
export { SvgCheckCircleOutline24 as ReactComponent };